import { clsx } from 'clsx';

import Typography, { Variants } from '../typography';
import { Box } from '@material-ui/core';
import {
  ExpandLess as ExpandLessIcon,
  ExpandMore as ExpandMoreIcon,
} from '@material-ui/icons';

import useStyles from './styles';

import type { FontWeight } from '../typography';
import type { BaseProps } from '../../../interfaces';

export function CustomKeyValueBox(props: Props) {
  const {
    value,
    label,
    labelFontWeight,
    valueFontWeight,
    labelVariant = Variants.Caption1,
    valueVariant = Variants.Caption1,
    classes = {},
    isDetailOpened = false,
    showIcon = false,
  } = props;

  const _classes = useStyles();

  const DetailButtonIcon = isDetailOpened ? ExpandLessIcon : ExpandMoreIcon;

  return (
    <div className={clsx(_classes.root, classes?.root)}>
      <Box display='flex' alignItems='center'>
        <Typography
          classes={{ root: clsx(classes?.label) }}
          fontWeight={labelFontWeight}
          variant={labelVariant}
        >
          {label}
        </Typography>
        {showIcon && (
          <DetailButtonIcon
            classes={{
              root: clsx(
                _classes.detailHeaderIconRoot,
                classes?.detailHeaderIconRoot,
              ),
            }}
          />
        )}
      </Box>
      <Typography
        classes={{ root: clsx(classes?.value) }}
        fontWeight={valueFontWeight}
        variant={valueVariant}
      >
        {value}
      </Typography>
    </div>
  );
}

interface Props extends BaseProps {
  label: string;
  labelVariant?: Variants;
  labelFontWeight?: FontWeight;
  value: number | string;
  valueVariant?: Variants;
  valueFontWeight?: FontWeight;
  isDetailOpened?: boolean;
  showIcon?: boolean;
}
